/**
 * Add Connection Floating Action Button
 */

import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface AddConnectionFabProps {
  onClick: () => void;
}

export const AddConnectionFab: React.FC<AddConnectionFabProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('documentSources.addConnection')}>
      <Fab
        color="primary"
        aria-label="add"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        onClick={onClick}
      >
        <AddIcon />
      </Fab>
    </Tooltip>
  );
};